// Sitewide scroll-in reveal for homepage/marketing tiles — docs/02 "Motion"
// asks for animation throughout, not just the product grid. Tags matching
// elements with [data-ag-observe] (CSS in ag-base.css) and staggers them
// with a short per-item delay within their own container.
const SELECTOR = [
  '.ag-hero__tile',
  '.ag-trust__tile',
  '.ag-cats__head',
  '.ag-cats__tile',
  '.ag-rail__head',
  '.ag-lines__panel',
  '.ag-look__card',
  '.ag-look__media',
  '.ag-review-card',
  '.ag-reviews__summary',
  '.ag-ugc__tile',
  '.ag-story__media',
  '.ag-story__copy',
].join(',');

function init() {
  const els = document.querySelectorAll(SELECTOR);
  if (!els.length) return;

  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const byParent = new Map();
  els.forEach((el) => {
    el.setAttribute('data-ag-observe', '');
    const parent = el.parentElement;
    const i = byParent.get(parent) || 0;
    el.style.transitionDelay = `${Math.min(i, 6) * 70}ms`;
    byParent.set(parent, i + 1);
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach((el) => io.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
